import { createFileRoute } from '@tanstack/react-router'
import { Optin } from '../../components/Optin.tsx'

export const Route = createFileRoute('/_public/optin/$secret')({
	component: Optin,
})
